import styled from 'styled-components'

import { typeScale, CSS_ELEMENTS_RESETS, THEME, COLORS } from '../../styles'
import Button from '../Button'
import RecipeFeedbackComment from '../RecipeFeedbackComment'
import RecipeAuthorBadge from '../RecipeAuthorBadge'
import Icon from '../Icon'
import SpinnerLoader from '../SpinnerLoader'

const Styled = styled.div`
  position: relative;
`
Styled.stars = styled.div`
  display: inline-block;
  position: relative;
  top: 0.2rem;
  left: 0.8rem;
`
Styled.starsInner = styled.div`
  display: flex;
`
Styled.headline = styled.header`
  ${typeScale('button')};
  position: relative;
  padding: 2.4rem 2.4rem 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
`
Styled.count = styled.div`
  ${typeScale('body', { lineHeight: 'normal' })};
  flex: 1;
  color: ${COLORS.primary};
  padding: 0 0.8rem 0 0.4rem;
  text-align: left;
`
Styled.noCount = styled.div`
  ${typeScale('button', { lineHeight: 'normal' })};
  flex: 1;
  color: ${THEME.COLORS.foreground.primary};
  padding: 0 0.8rem 0 0;
  text-align: left;
  text-transform: capitalize;
`
Styled.comment = styled(RecipeFeedbackComment)`
  padding: 1.2rem 0;
  position: relative;
  border-bottom: 0.1rem dashed ${THEME.COLORS.foreground.secondary};

  &:last-child {
    border-bottom: 0;
  }
`
Styled.writeCommentButton = styled.div`
  display: inline-flex;
  background-color: ${COLORS.powder};
  border-radius: 9999px;
  padding: 0.8rem 1.2rem;
  cursor: pointer;
  user-select: none;
`
Styled.writeCommentButtonIcon = styled(Icon)`
  width: 1.6rem;
  height: 1.6rem;
`
Styled.writeCommentButtonText = styled.span`
  ${typeScale('caption', { lineHeight: 'normal' })};
  color: ${COLORS.black};
  padding-left: 0.4rem;
  display: inline-block;
`
Styled.thanks = styled.div`
  display: inline-flex;
  padding-left: 1.2rem;
`
Styled.thanksText = styled.span`
  ${typeScale('caption', { lineHeight: 'normal' })};
  padding-right: 0.4rem;
  display: inline-block;
`
Styled.thanksIcon = styled(Icon)`
  width: 1.6rem;
  height: 1.6rem;
`
Styled.write = styled.button`
  ${CSS_ELEMENTS_RESETS.button};
  ${typeScale('body')};
  color: ${COLORS.primary};
  display: block;
  cursor: pointer;
  position: absolute;
  top: 2.4rem;
  right: 2.4rem;
  background: none;
  text-decoration: none;
`
Styled.form = styled.div`
  width: 100%;
`
Styled.tile = styled.button`
  ${CSS_ELEMENTS_RESETS.button};
  ${typeScale('body')};
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${THEME.COLORS.background.secondary};
  white-space: pre;
  min-height: ${({ size }) => (size === 'large' ? '10rem' : 'auto')};
  margin: 0.8rem;
  padding: 1.2rem 1.6rem;
  border-radius: 1.6rem;
  border-style: solid;
  border-width: 0.2rem;
  border-color: ${({ checked }) =>
    checked
      ? THEME.COLORS.foreground.primary
      : THEME.COLORS.foreground.tertiary};
`
Styled.question = styled.p`
  ${typeScale('button')};
  padding-bottom: 1.6rem;
  width: 100%;
  text-align: center;
`
Styled.rating = styled.div`
  margin: 0.8rem;
  width: calc(50% - 1.6rem);
  cursor: pointer;
  background: none;
  padding: 0.8rem 1.6rem 1.2rem;
  border-radius: 1.6rem;
  min-height: 10rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column nowrap;
  border-style: solid;
  border-width: 0.2rem;
  border-color: ${({ checked }) =>
    checked
      ? THEME.COLORS.foreground.primary
      : THEME.COLORS.foreground.tertiary};
`
Styled.star = styled.svg`
  display: inline-block;
  margin-right: 0.2rem;
`
Styled.text = styled.div`
  padding-top: 0.4rem;
`
Styled.textarea = styled.textarea`
  ${typeScale('body')};
  background: ${THEME.COLORS.background.primary};
  color: ${THEME.COLORS.foreground.primary};
  border-radius: 1.6rem;
  padding: 1.6rem;
  width: 100%;
  appearance: none;
  display: block;
  height: 10rem;
  border: 0;

  &::placeholder {
    color: ${THEME.COLORS.foreground.secondary};
  }
`
Styled.footer = styled.footer`
  padding-top: 3.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`
Styled.submit = styled(Button)`
  display: inline-block;
  line-height: normal;
  padding: 1.2rem 1.6rem;
`
Styled.comments = styled.div`
  padding: 0 2.4rem 1.2rem;
`
Styled.drawerTitle = styled.h2`
  ${typeScale('headline2')};
  padding-bottom: 3.2rem;
  text-align: center;
`
Styled.summary = styled.div`
  padding-bottom: 3.2rem;
`
Styled.summaryTitle = styled.div`
  ${typeScale('body')};
  text-align: center;
  padding-bottom: 0.4rem;

  strong {
    font-weight: bold;
  }
`
Styled.summaryAuthor = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
Styled.summaryAuthorName = styled(RecipeAuthorBadge)``
Styled.seeMoreFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 2.4rem 2.4rem;
`
Styled.seeMoreButton = styled.div`
  background-color: ${COLORS.powder};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  padding: 0.8rem 1.6rem;
  cursor: ${({ isLoading }) => (isLoading ? 'wait' : 'pointer')};
`
Styled.seeMoreLabel = styled.div`
  ${typeScale('caption')};
  color: ${COLORS.black};
  display: inline-block;
  padding-right: 0.8rem;
`
Styled.seeMoreIcon = styled(Icon)`
  width: 1.6rem;
  height: 1.6rem;
`
Styled.seeMoreLoading = styled(SpinnerLoader)`
  width: 1.6rem;
  height: 1.6rem;
`
Styled.noComment = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 1.2rem 0;
`
Styled.noCommentLoading = styled(SpinnerLoader)`
  width: 1.6rem;
  height: 1.6rem;
`
Styled.noCommentLabel = styled.p`
  ${typeScale('caption')};
  color: ${THEME.COLORS.foreground.secondary};
  text-align: left;
  flex: 1;
  padding-left: 0.8rem;

  &:first-child {
    padding-left: 0;
  }
`

export default Styled
